import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewKeys = (params) => {
    return axios.get(`${backendHost}/api/admin/keys/view`, {params});
};

export {
    getViewKeys
}